import BaseModel from '../../base/BaseModel.model';
export default class FieldArea extends BaseModel {
    public areaId?: number;
    public code?: string;
    public name?: string; 
    public description?: string;
    constructor(){
        super();
        this.init();
    }

    init(){
        this.areaId = 0;
        this.code = "";
        this.name = "";
        this.description ="";
    }
}